// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'vehicle-search-modal',
    templateUrl: './vehicle-search-modal.component.html',
    styleUrls: ['./vehicle-search-modal.component.scss'],
})
export class VehicleSearchModal {
    constructor(private dialogRef: MatDialogRef<VehicleSearchModal>) {}

    public close(): void {
        this.dialogRef.close();
    }

    public selectVehicle(event: any): void {
        this.dialogRef.close(event);
    }
}
